import { Collapse } from "antd";
import { questionTypes } from "../../../../utils/surveys";
import { QuestionsListItem } from "./QuestionsListItem";
import { DeleteFilled } from "@ant-design/icons";
import { useFormContext } from "react-hook-form";
import { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";

export const QuestionsList = ({
    questions,
    onDeleteQuestion,
    questionsName,
    pageIndex,
    move,
}) => {
    const {
        watch,
        formState: { errors },
    } = useFormContext();

    const setBorderRadius = (questionIndex) => {
        if (questionIndex === 0 && questionIndex === questions.length - 1)
            return "8px";
        if (questionIndex === 0 && questionIndex !== questions.length - 1)
            return "8px 8px 0 0";
        if (questionIndex === questions.length - 1) return "0 0 8px 8px";
        return "0";
    };

    const collapseProps = () => {
        return questions.map((question, index) => ({
            key: question.id,
            label: (
                <CollapseHeader
                    move={move}
                    index={index}
                    question={watch(`${questionsName}[${index}]`)}
                />
            ),
            children: (
                <QuestionsListItem
                    questionName={`${questionsName}[${index}]`}
                    question={question}
                    questionIndex={index}
                />
            ),
            extra: (
                <DeleteQuestionIcon
                    onDelete={onDeleteQuestion.bind(null, question.id)}
                />
            ),
            ...{
                ...(errors?.pages?.[pageIndex]?.questions?.[index] && {
                    style: {
                        border: "1px solid #ff0000",
                        borderRadius: setBorderRadius(index),
                    },
                }),
            },
        }));
    };

    return <Collapse accordion items={collapseProps()} />;
};

function DeleteQuestionIcon({ onDelete }) {
    const deleteQuestionHandler = (e) => {
        e.stopPropagation();
        onDelete();
    };

    return (
        <div onClick={deleteQuestionHandler}>
            <DeleteFilled />
        </div>
    );
}

function CollapseHeader({ question, index, move }) {
    const ref = useRef(null);

    const [{ handlerId }, drop] = useDrop({
        accept: "item",
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            };
        },
        hover(item, monitor) {
            if (!ref.current) {
                return;
            }
            const dragIndex = item.index;
            const hoverIndex = index;

            if (dragIndex === hoverIndex) {
                return;
            }

            const hoverBoundingRect = ref.current?.getBoundingClientRect();
            const hoverMiddleY =
                (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            const clientOffset = monitor.getClientOffset();
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;

            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }

            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }

            move(dragIndex, hoverIndex);

            item.index = hoverIndex;
        },
    });

    const [{ isDragging }, drag] = useDrag({
        type: "item",
        item: () => {
            return { id: question?.id, index: index };
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });
    drag(drop(ref));

    return (
        <div ref={ref} style={{ width: "100%", opacity: isDragging ? 0.2 : 1 }}>
            <p>
                {
                    questionTypes.find(
                        (qtype) => question?.type === qtype.value
                    )?.label
                }
                {question.headline && (
                    <>
                        {" "}
                        -{" "}
                        <span style={{ fontWeight: 700 }}>
                            {" "}
                            {question.headline.length < 20
                                ? question.headline
                                : `${question.headline.slice(0, 20)}...`}
                        </span>
                    </>
                )}
            </p>
        </div>
    );
}
